export type RestoreOriginalRedirectUrlParams = {
  fullRedirectUrlValue: string;
  originalParams: URLSearchParams;
  excludedParams: string[];
};

/**
 * Additively restores original page params that SIS dropped when rebuilding a redirect URL, so the
 * flow keeps its context on retry.
 *
 * The redirect URL wins: a param is only restored when the URL doesn't already include it, and
 * `excludedParams` (e.g. the now-invalid handoff token) are never restored.
 */
export const restoreOriginalRedirectUrlParams = ({
  fullRedirectUrlValue,
  originalParams,
  excludedParams,
}: RestoreOriginalRedirectUrlParams): string => {
  const fullRedirectUrl = new URL(fullRedirectUrlValue);

  originalParams.forEach((value, key) => {
    if (!excludedParams.includes(key) && !fullRedirectUrl.searchParams.has(key)) {
      fullRedirectUrl.searchParams.set(key, value);
    }
  });

  return fullRedirectUrl.toString();
};
